import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Table,
  Text,
  Dropdown,
  Breadcrumb,
  cn
} from "@artprov/design-system";
import { columnasSolicitudes } from '../columnasSolicitud';
import { getTiposSolicitud } from '../../../services/tipo-solicitud/tiposSolicitud.service';
import { tiposSolicitudAdapter } from '../../../services/adapters/tipoComprobante.adapter'
import ModalAutorizantes from './ModalAutorizantes';
import { getRolUsuario } from '../../../services/user/user.service';
import { FeedbackModal } from '../../nueva-solicitud/components/FeedbackModal';
import ModalMensaje from './ModalObservaciones';

export default function Contenido({ data, openModalAutorizantes, onCloseModalAutorizaciones, openModalObservacion, closeModalObservacion, autorizantes = [], dataObservacion = {} }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [openFaltaCuentaModal, setOpenFaltaCuentaModal] = useState(false)
  const { id } = useParams();
  const isNumberOne = id === '1';
  const solicitudes = isNumberOne ? [] : data;
  const [dropdownOpcionesDelMenu, setDropdownOpcionesDelMenu] = useState([]);
  const [cargandoValidacion, setCargandoValidacion] = useState(false)
  const [selectedRow, setSelectedRow] = useState([]);

  useEffect(() => {
    const init = async () => {
      let tiposSolicitud = await getTiposSolicitud();
      let tiposSolicitudDataAdapted = tiposSolicitudAdapter(tiposSolicitud);
      setDropdownOpcionesDelMenu(tiposSolicitudDataAdapted.rows)
    }
    init();
  }, []);

  const emptyState = {
    icon: 'info',
    title: 'Aún no tenés solicitudes generadas',
    description: 'Para crear una nueva, presioná el botón \'Nueva Solicitud\'.',
    containerStyles: '',
    iconStyles: 'text-warning-10',
    titleStyles: 'text-primary-10',
    descriptionStyles: '',
  };

  const getDropdownOpcionesDelMenu = () => {
    const dropdownOpcionesDelMenuToDom = dropdownOpcionesDelMenu.map((el) => {
      return { icon: '', opcion: el.nombre, onClick: () => handleDropdownClick(el.nombre, el.id) }
    })
    return dropdownOpcionesDelMenuToDom;
  }

  const handleDropdownClick = async (opcion, id) => {
    setCargandoValidacion(true)
    try {
      const validacionData = await getRolUsuario()
      if (!validacionData?.puedeSolicitarRendicion) {
        setOpenFaltaCuentaModal(true)
      } else {
        const formattedOption = opcion.toLowerCase().replace(/ /g, "-");
        navigate(`/nueva-solicitud/${formattedOption}`, {
          state: {
            idTipoSolicitud: id,
          }
        });
      }
    } catch { }
    finally {
      setCargandoValidacion(false)
    }
  };

  return (
    <>
      <div className={`container mx-auto flex flex-col h-full  min-h-[800px] items-center my-8 px-2 xl:px-8`}>
        <div className="w-full flex flex-col justify-center gap-y-1 p-2">
          <Breadcrumb
            customItems={getBreadCrumbs()}
            onClick={(href) => {
              if (href) navigate(href);
            }}
          />
        </div>
        <div className="w-full flex flex-col justify-between p-1">
          <Text variant="h6" className="text-primary-10">Solicitudes de Reintegro y Anticipo</Text>
          <Text variant="body2 text-tertiary-0" >Enviá nuevas solicitudes, consultá el estado de tus solicitudes enviadas y gestioná las que necesiten una acción de tu parte.</Text>
        </div>
        <div className="w-full flex flex-row justify-between gap-y-1">

          <Dropdown
            disabeld={cargandoValidacion}
            textButton={"Nueva Solicitud"}
            variant="outline"
            className="ml-auto"
            opcionesDelMenu={getDropdownOpcionesDelMenu()}
            classNameContainerOpciones={"min-w-60"}
          />
        </div>
        <div className="w-full min-h-[300px] flex flex-col gap-y-2 my-2">
          <Table
            data={solicitudes}
            selectable={false}
            columns={columnasSolicitudes}
            emptyState={emptyState}
            selected={selectedRow}
          />
        </div>
      </div>
      <ModalMensaje
        titulo={dataObservacion.titulo}
        mensaje={dataObservacion.mensaje}
        subtitulo={dataObservacion.subtitulo}
        openModal={openModalObservacion}
        onCloseModal={closeModalObservacion}
      />
      <ModalAutorizantes
        openModal={openModalAutorizantes}
        autorizantes={autorizantes}
        onCloseModal={onCloseModalAutorizaciones}
      />
      <FeedbackModal onIconClose={() => setOpenFaltaCuentaModal(false)} className={cn("pt-3 min-h-[390px]")} labelAccept={"Aceptar"} open={openFaltaCuentaModal} onAccept={() => setOpenFaltaCuentaModal(false)} setOpen={setOpenFaltaCuentaModal} title={"Registrar cuenta bancaria"} variant={"warning"} message={"Para continuar con la solicitud de Reintegro en cuenta, necesitás tener una cuenta bancaria registrada.|Si la registrás, vas a poder continuar con la solicitud. |Si aún no la tenés, contactate con Personas y Cultura para actualizar tus datos bancarios."} />
    </>
  )
}

Contenido.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  openModalAutorizantes: PropTypes.bool,
  onCloseModalAutorizaciones: PropTypes.func,
  openModalObservacion: PropTypes.bool,
  closeModalObservacion: PropTypes.func,
  autorizantes: PropTypes.array,
  dataObservacion: PropTypes.object,
};

function getBreadCrumbs() {
  return [
    { label: "Inicio", href: "/", disabled: false },
  ];
}